import { render, staticRenderFns } from "./InventoryCreateOrUpdateView.vue?vue&type=template&id=56fc44c6&"
import script from "./InventoryCreateOrUpdateView.vue?vue&type=script&lang=js&"
export * from "./InventoryCreateOrUpdateView.vue?vue&type=script&lang=js&"
import style0 from "./InventoryCreateOrUpdateView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports